import { instance } from "api/apiBase";
import { normalizeFilename } from "shared/utils";

export const getPropertyPresigned = async (file: File, sessionKey: string) => {
  const queryParams = new URLSearchParams({
    session_key: sessionKey,
    size: file.size.toString(),
    filename: normalizeFilename(file.name),
    type: file.type
  });

  const { data } = await instance(
    `/portal/v1/listings/assets/presign?${queryParams}`
  );

  return data;
};
